'use client';
import { useEffect } from 'react';
 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import CompanyIntroSection from'./components/CompanyIntroSection';
 import WhyChooseUsSection from'./components/WhyChooseUsSection';
 import SocialProofSection from'./components/SocialProofSection';
 import WhatsAppButton from'../homepage/components/WhatsAppButton';

export default function AboutPage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach(el => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <>
      <Header />
      <main className="pt-20">
        <CompanyIntroSection />
        <WhyChooseUsSection />
        <SocialProofSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  )
}